import { MessageSquare, Plus } from 'lucide-react';

export const SidebarConversationsSection = ({ conversations, selectedConversation, onSelectConversation, onNewConversation }) => (
  <div className="flex flex-1 flex-col space-y-3 overflow-hidden">
    <div className="flex items-center justify-between">
      <h3 className="text-xs font-mono uppercase tracking-widest text-muted-foreground/60">
        Historique
      </h3>
      <button
        data-testid="new-conversation-button"
        onClick={onNewConversation}
        className="rounded p-1 transition-colors hover:bg-zinc-900/50"
        title="Nouvelle conversation"
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>

    <div className="flex-1 space-y-2 overflow-y-auto" data-testid="conversations-list">
      {conversations.length === 0 ? (
        <div className="py-8 text-center text-xs text-muted-foreground">Aucune conversation</div>
      ) : (
        conversations.map((conv) => (
          <button
            key={conv.id}
            data-testid={`conversation-${conv.id}`}
            onClick={() => onSelectConversation(conv)}
            className={`w-full rounded-sm border p-3 text-left text-sm transition-all duration-300 ${
              selectedConversation?.id === conv.id
                ? 'border-zinc-700 bg-white/5'
                : 'border-transparent bg-transparent hover:border-zinc-800 hover:bg-zinc-900/30'
            }`}
          >
            <div className="flex items-start gap-2">
              <MessageSquare className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="truncate text-xs">{conv.title}</div>
              </div>
            </div>
          </button>
        ))
      )}
    </div>
  </div>
);
